import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Combobox } from '@/components';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { APPLICATION_EVENT_TYPES, IDENTITY_EVENT_TYPES } from '../constants';
import { useEventTypeLabel } from '../hooks/useEventTypeLabel';

interface LogsEventTypesFilterProps {
    selected: string[];
    onChange: (next: string[]) => void;
    onClear: () => void;
}

export function LogsEventTypesFilter({
    selected,
    onChange,
    onClear,
}: LogsEventTypesFilterProps) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const eventTypeLabel = useEventTypeLabel();
    const [search, setSearch] = useState('');

    const normalizedSearch = search.trim().toLowerCase();
    const options = [...IDENTITY_EVENT_TYPES, ...APPLICATION_EVENT_TYPES]
        .map((eventType) => ({
            value: eventType,
            label: eventTypeLabel(eventType),
        }))
        .filter((option) =>
            option.label.toLowerCase().includes(normalizedSearch),
        )
        .sort((first, second) => first.label.localeCompare(second.label));

    const toggle = (type: string) => {
        onChange(
            selected.includes(type)
                ? selected.filter((existing) => existing !== type)
                : [...selected, type],
        );
    };

    return (
        <Combobox
            title={t('logs.eventTypesLabel')}
            options={options}
            selected={selected}
            onToggle={toggle}
            onClear={selected.length > 0 ? onClear : undefined}
            onSearch={setSearch}
            searchPlaceholder={t('logs.searchEventTypes')}
            autoFocus
            emptyText={t('logs.noMatches')}
            clearLabel={t('logs.clearFilter')}
        />
    );
}
